(function ($) {
	$.manageErrors = function ($form, errors) {
        $form.find('.form-text').remove();

		for (var error in errors) {
			var msgErrors = errors[error];

			msgErrors.forEach(function (msg) {
                $form.find('[name="' + error + '"]')
                    .addClass('is-invalid')
                    .closest('.form-group')
                    .append('<span class="form-text"><i class="icon icon-6"></i> ' + msg + '</span>');
			});
		}
	}
}(jQuery));